<script setup>
import {defineProps, ref} from 'vue';
import ParticipantsTableAdminIsolate from './participants/ParticipantsTableAdminIsolate.vue';
import ParticipantsTableAdmin from './participants/ParticipantsTableAdmin.vue';

const props = defineProps({
  training: {type: Object},
});

const tableIsolate = ref(window.appGlobal.configs.trainingModuleTableIsolate);
</script>
<template>
  <ParticipantsTableAdminIsolate
    v-if="tableIsolate"
    :participants="training.participantsDetails"
  />
  <ParticipantsTableAdmin
    v-else
    :id="training.id"
    :participants="training.participantsDetails"
    :files-participants="training.filesParticipants"
    :training="training"
  />
</template>
